import * as types from './types';
const initialState = {
  status: 'Data',
  dataInspect: {},
  data: [],
  error: null,
  success: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.INSPECT:
      return {
        ...state,
        status: 'DataInspect',
        dataInspect: action.payload,
      };
    case types.GET_DATA:
      return {
        ...state,
        data: action.payload.annotatedImages,
      };
    case types.CONFIRM_INSPECT:
      return {
        ...state,
        success: action.payload,
      };
    case types.HAS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.PAGE_DATA:
      return {
        status: 'Data',
        dataInspect: {},
        success: false,
      };

    case types.SET_SESSION_DETAILS_DATA: {
      const { damage_table, cage_branding, damages_source } =
        action.payload?.options;
      return {
        ...state,
        damage_table,
        cage_branding,
        damages_source,
      };
    }
    default:
      return state;
  }
}
